<template>
  <div class="ListSliderWrapper" :style="cssVars">
    <div class="ListSlider">
      <div class="relative">
        <div class="swiper-container text-white">
          <div v-if="!isOnEnd && computedConfig.allowedGhost" class="GhostStart"></div>
          <div v-if="!isOnEnd && computedConfig.allowedGhost" class="GhostEnd"></div>

          <div class="swiper-wrapper">
            <slot>
              <div class="swiper-slide" v-for="(dataRow, dataIndex) in data" :key="dataIndex">
                <component
                  :is="computedConfig.cardTemplate"
                  :[computedConfig.attrTemplate]="dataRow"
                />
              </div>
            </slot>
          </div>
        </div>

        <!-- DEBUG -->
        <!-- {{ arrowsInfo }} -->

        <div
          v-if="showArrows && arrowsInfo?.allowArrows && !arrowsInfo?.isOnStart"
          @click="slidePrev()"
          class="swiper-prev w-14 h-14 flex items-center justify-center border border-border-common absolute z-5 cursor-pointer top-1/2 -left-7 transform -translate-y-1/2 rounded-full bg-white text-black"
        >
          <aw-icon icon="arrow-left" class="w-10 h-10" />
        </div>

        <div
          v-if="showArrows && arrowsInfo?.allowArrows && !arrowsInfo?.isOnEnd"
          @click="slideNext()"
          class="swiper-next w-14 h-14 flex items-center justify-center absolute z-5 cursor-pointer top-1/2 -right-7 transform -translate-y-1/2 rounded-full bg-white text-black"
        >
          <aw-icon icon="arrow-left" class="w-10 h-10 transform rotate-180" />
        </div>
      </div>

      <div v-if="showDots" class="swiper-pager mt-8" ref="pager"></div>
    </div>
  </div>
</template>
<script>
import Swiper from 'swiper/swiper-bundle'
import { mapGtmItemsFromProducts, trackViewItemList } from '../gtm'

export default {
  props: {
    config: {
      type: Object,
      default: () => {}
    },
    sliderConfig: {
      type: Object,
      default: () => {}
    },
    data: {
      type: Object,
      required: false
    },
    productListName: String,
    showArrows: {
      type: Boolean,
      default: true
    },
    showDots: {
      type: Boolean,
      default: false
    },
    enableGtmTracking: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      swiper: null,
      isOnStart: true,
      isOnEnd: false,
      pager: null,
      currentBreakpoint: 1,
      isMounted: false,
      observer: null
    }
  },
  mounted() {
    //  https://github.com/nolimits4web/Swiper/issues/2185
    if (this.enableGtmTracking) {
      this.observer = new IntersectionObserver(this.handleIntersect)
      this.observer.observe(this.$el)
    }

    this.swiper = new Swiper(
      this.$el.firstElementChild.firstElementChild.firstElementChild,
      this.computedSliderConfig
    )

    this.swiper.on('slideChange', swiper => {
      this.isOnStart = swiper.isBeginning
      this.isOnEnd = swiper.isEnd
    })

    // tyhle eventy nefunguje a je jedno jestli jsou v nextTicku nebo ne, funguji naprimo pouze v instance new Swiper, viz defaultConfig, mozna starsi verzi?

    // this.swiper.on('beforeInit', swiper => {
    //   console.log('beforeInit', swiper)
    // })

    // this.swiper.on('afterInit', swiper => {
    //   console.log('afterInit', swiper)
    // })

    // this.swiper.on('init', swiper => {
    //   console.log('init', swiper)
    // })

    this.swiper.on('breakpoint', swiper => {
      this.currentBreakpoint = swiper.currentBreakpoint
    })

    this.isMounted = true
  },
  computed: {
    computedConfig() {
      return {
        ...this.defaultConfig(),
        ...this.config
      }
    },
    computedSliderConfig() {
      return {
        ...this.defaultSliderConfig(),
        ...this.sliderConfig
      }
    },
    slidesPerView() {
      //return 5 // kvuli sipce, nemam doresene stara verze, neni poznat kdy se ma slidovat dopredu a dozadu a na DK jsou dynamicke sirky ...

      return this.computedSliderConfig.breakpoints
        ? this.computedSliderConfig.breakpoints[this.currentBreakpoint].slidesPerView
        : this.computedSliderConfig.slidesPerView
    },
    cssVars() {
      return {
        '--slidesPerView': this.slidesPerView
      }
    },
    arrowsInfo() {
      if (!this.isMounted) {
        return {}
      }
      return {
        slidesPerView: this.slidesPerView,
        isOnStart: this.isOnStart,
        isOnEnd: this.isOnEnd,
        slides: this.swiper.slides.length,
        allowArrows: true /*this.swiper.slides.length > this.slidesPerView*/
      }
    }
  },
  methods: {
    handleIntersect(entries) {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          trackViewItemList(
            mapGtmItemsFromProducts(this.data, this.productListName), 
            this.productListName
          )
          this.observer.unobserve(this.$el)
        }
      })
    },
    defaultConfig() {
      return {
        cardTemplate: 'product-slider-card',
        attrTemplate: 'product',
        allowedGhost: true
      }
    },
    defaultSliderConfig() {
      return {
        slidesPerView: 6,
        slidesPerGroup: 5,
        pagination: {
          el: this.pager,
          clickable: true,
          renderBullet: function (index, className) {
            return '<span class="' + className + '"></span>'
          }
        },
        speed: 750,
        loop: false,
        autoplay: false,
        spaceBetween: 15,
        on: {
          init: swiper => {
            this.currentBreakpoint = swiper.currentBreakpoint
          }
        }
      }
    },
    slideTo(index) {
      if (this.swiper) {
        this.swiper.slideTo(index)
      }
    },
    slidePrev() {
      if (this.swiper) {
        this.swiper.slidePrev()
      }
    },
    slideNext() {
      if (this.swiper) {
        this.swiper.slideNext()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.ListSliderWrapper {
  @apply relative z-1;
}

.ListSlider {
  @apply relative z-1;
}

.ProductListSlider :deep(.GhostEnd) {
  @apply absolute top-0 bottom-0 right-0 z-4;
  background: linear-gradient(to left, #fff 40%, rgba(255, 255, 255, 0.01)) repeat-x;
  width: calc(100% / var(--slidesPerView) / 2);
}

.ProductListSlider :deep(.Ghost.Ghost--Gray) {
  background: linear-gradient(to left, rgba(243, 243, 243, 1) 40%, rgba(243, 243, 243, 0.01))
    repeat-x;
}
</style>
